

    <div class="row">

   
        <div class="col-12 dateSelector">
            <button nbbutton 
            class="btn-round"   (click)="previous()" >
                <nb-icon icon="chevron-left-outline"></nb-icon>
            </button>

            <div style="font-weight:800; font-size:large; text-align: center; width: 300px;">{{dayTitle}}</div>

            <button nbbutton class="btn-round"  (click)="next()" >
                <nb-icon icon="chevron-right-outline"></nb-icon>
             </button>



        </div>


    </div>



<ngx-food-diary-app [patientId]="patientId" [userId]="userId" [day]="day"></ngx-food-diary-app>